import { render, staticRenderFns } from "./fork_info.vue?vue&type=template&id=3850819c"
import script from "./fork_info.vue?vue&type=script&lang=js"
export * from "./fork_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports